<!--
  - Copyright (c) 2019. Mr.Professor
  -->

<template>
    <div class="chart">
        <div class="d-flex justify-content-between p-3">
            <h1>По направлениям</h1>
            <select name="" id="" v-model="type" class="custom-select w-50">
                <option value="weekly">Неделя</option>
                <option value="monthly">Месяц</option>
                <option value="annual">Год</option>
            </select>
        </div>
        <p class="justify-content-between pl-3">{{ tripsFromDate + ' - ' + tripsToDate }}</p>
        <apexchart type=bar height=350 :options="options" :series="series"/>
    </div>
</template>

<script>
    export default {
        name: "TripsDashboard",
        data() {
            return {
                type: 'weekly',
                series: [],
                options: {
                    chart: {
                        height: 350,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            plotOptions: {
                                columnWidth: '55%',
                                endingShape: 'rounded'
                            },
                            dataLabels: {
                                position: 'top', // top, center, bottom
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -20,
                        style: {
                            fontSize: '12px',
                            colors: ["#304758"]
                        }
                    },

                    xaxis: {
                        categories: ['-'],
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        },
                        crosshairs: {
                            fill: {
                                type: 'gradient',
                                gradient: {
                                    colorFrom: '#D8E3F0',
                                    colorTo: '#BED1E6',
                                    stops: [0, 100],
                                    opacityFrom: 0.4,
                                    opacityTo: 0.5,
                                }
                            }
                        },
                        tooltip: {
                            enabled: false,
                            offsetY: -35,

                        }
                    },
                    fill: {
                        gradient: {
                            shade: 'light',
                            type: "horizontal",
                            shadeIntensity: 0.25,
                            gradientToColors: '#BED1E6',
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 0.5,
                            stops: [50, 0, 100, 100]
                        },
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        /*labels: {
                            show: false,
                            formatter: function (val) {
                                return val + "%";
                            }
                        }
*/
                    }
                },
				tripsFromDate: '',
				tripsToDate: ''
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let data = {};
                data[this.type] = true;
                this.$api.get('dashboard.trips-chart', data)
                    .then(({data}) => {
                        this.series = data.data;
						this.tripsFromDate = this.$moment(data.range.from.date).format('Y-MM-DD');
						this.tripsToDate = this.$moment(data.range.to.date).format('Y-MM-DD');
                    })
            }
        },
        watch: {
            type: function () {
                this.init();
            }
        }
    }
</script>

<style scoped>

</style>
